import usePhone from "./usePhone";

export default usePhone;
